import get from 'lodash/get';
import { figureOutPriorityTag } from '../../../../utils/ad_util';

// const { PIANO_AID, PIANO_URL, PIANO_API_URL } = process.env;
const PIANO_URL = 'api.tinypass.com/';
const PIANO_API_URL = 'api.tinypass.com/';

let PIANO_AID = 'UnG6aKcRpu';
if (process.env.NODE_ENV === 'development' || process.env.STAGE === 'true') {
  PIANO_AID = 'OS0jhrE0pu';
}

const buildCustomParams = context => {
  const {
    type,
    postData,
    categoryPageData
    // tagPageData,
    // authorPageData,
    // searchPageData,
    // staticPageData,
    // mostCreativePeoplePageData,
    // personPageData,
    // statusCode,
    // ibdPageData,
    // companyPageData,
    // micYearPageData,
    // micSectorPageData,
    // videoPageData,
    // productPageData,
    // playlistAllFeedData,
    // config
  } = context;

  // DEBUG for your data inputs!
  // console.log('🎹 Debug: Page Context Object --', '\n', context);

  const typeLookup = {
    post() {
      const tags = get(postData, 'tags', []);
      const eyeBrowText = figureOutPriorityTag(tags);

      let author = '';
      if (postData.author && postData.author.name !== '') {
        author = postData.author.name;
      }

      let primaryCategory = '';
      if (
        postData.categories &&
        postData.categories.length > 0 &&
        postData.categories[0] !== undefined
      ) {
        primaryCategory = postData.categories[0].name;
      }

      let subCategory = '';
      if (
        postData.categories &&
        postData.categories.length > 0 &&
        postData.categories[1] !== undefined
      ) {
        subCategory = postData.categories[1].name;
      } else {
        subCategory = primaryCategory;
      }

      const subSubCategory =
        get(eyeBrowText, 'slug') !== '' ? get(eyeBrowText, 'slug') : 'misc';

      const pubdate = postData.omnitureDate ? `${postData.omnitureDate}` : '';

      const isSponsored = !!tags.filter(tag =>
        tag.name.includes('_advertorial')
      ).length;

      let pageType = 'article';
      if (get(postData, 'posterSlideshow.length')) {
        pageType = 'slideshow';
      } else if (
        get(postData, 'hasVideoPoster') === true ||
        get(postData, 'posterVideo.feedId')
      ) {
        pageType = 'video';
      }

      return `
        tp.push(["setContentSection", "${primaryCategory}"]);
        // tp.push(["setContentSection", "${subCategory}"]);
        tp.push(["setContentAuthor", "${author}"]);
        tp.push(["setContentCreated", "${pubdate}"]);
        tp.push(["setCustomVariable", "primaryCategory", "${primaryCategory}"]);
        tp.push(["setCustomVariable", "subCategory1", "${subCategory}"]);
        tp.push(["setCustomVariable", "subCategory2", "${subSubCategory}"]);
        tp.push(["setCustomVariable", "contentType", "${pageType}"]);
        tp.push(["setCustomVariable", "articleType", "${pageType}"]);
        tp.push(["setCustomVariable", "isSponsored", "${isSponsored}"]);
        tp.push(["setTags", [${get(postData, 'tags', [])
          .map(item => `"${get(item, 'name', '').replace(/"/g, '')}"`)
          .join()}]]);
      `;
    },
    category() {
      const pageType = 'category';
      const category = get(categoryPageData, 'slug', 'news');
      return `
        tp.push(["setContentSection", "${category}"]);
        tp.push(["setCustomVariable", "primaryCategory", "${category}"]);
        tp.push(["setCustomVariable", "contentType", "${pageType}"]);
      `;
    },
    homepage() {
      const pageType = 'homepage';
      return `
        tp.push(["setCustomVariable", "contentType", "${pageType}"]);
        tp.push(["setContentSection", "${pageType}"]);
      `;
    }
  };

  if (typeLookup[type]) {
    return typeLookup[type]();
  }

  return '';
};

export default function pianoInit(context = {}) {
  const customParamString = buildCustomParams(context);

  return `
    <!-- Piano -->
    <script>
      (function() {
        tp = window["tp"] || [];
        tp.push(["setAid", '${PIANO_AID}']);
        tp.push(["setEndpoint", 'https://${PIANO_API_URL}/api/v3']);

        ${customParamString}

        tp.push(["setUseTinypassAccounts", false ]);
        tp.push(["setUsePianoIdUserProvider", true ]);

        // Execute when the page is initially loaded
        tp.push(["init", function() {
            tp.pianoId.init({
                displayMode: 'modal',
            });
            tp.experience.init();
        }]);

        (function(src){
          var a=document.createElement("script");
          a.type="text/javascript";
          a.async=true;
          a.src=src;
          var b=document.getElementsByTagName("script")[0];
          b.parentNode.insertBefore(a,b)
        })("//${PIANO_URL}/xbuilder/experience/load?aid=${PIANO_AID}&ccb=z2x");
      })();
    </script>

    <!-- attempt adblk -->
    <script>
      document.cookie = "__adblocker=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      var setNptTechAdblockerCookie = function(adblocker) {
          var d = new Date();
          d.setTime(d.getTime() + 60 * 5 * 1000);
          document.cookie = "__adblocker=" + (adblocker ? "true" : "false") + "; expires=" + d.toUTCString() + "; path=/";
      };
      var script = document.createElement("script");
      script.setAttribute("async", true);
      script.setAttribute("src", "//www.npttech.com/advertising.js");
      script.setAttribute("onerror", "setNptTechAdblockerCookie(true);");
      document.getElementsByTagName("head")[0].appendChild(script);
    </script>
  `;
}
